import { HStack } from "@chakra-ui/react";
import { Homework } from "../../models/Homework";
import useAuthState from "../../state/auth.state";
import ApproveHomeworkButton from "./ApproveHomeworkButton";
import EditHomeworkButton from "./EditHomeworkButton";
import RejectHomeworkButton from "./RejectHomeworkButton";
import ShareHomeworkButton from "./ShareHomeworkButton";
import SubmitHomeworkButton from "./SubmitHomeworkButton";

type Props = {
  homework: Homework;
  refetchHomework: () => void;
};

export default function HomeworkActions({ homework, refetchHomework }: Props) {
  const { role } = useAuthState();
  let actions: JSX.Element | undefined = undefined;

  if (
    role === "ROLE_STUDENT" &&
    homework?.status !== "DONE" &&
    homework.status !== "REJECTED"
  ) {
    actions = (
      <HStack gap={4} p={4}>
        {homework?.status === "APPROVED" && (
          <ShareHomeworkButton homeworkId={homework.id} />
        )}
        {homework?.status === "STARTED" && (
          <>
            <EditHomeworkButton homework={homework} />
            <SubmitHomeworkButton
              homework={homework}
              refetchHomework={refetchHomework}
            />
          </>
        )}
      </HStack>
    );
  }

  if (role === "ROLE_TEACHER" && homework?.status === "DONE") {
    actions = (
      <HStack gap={4} p={4}>
        <ApproveHomeworkButton
          homeworkId={homework.id}
          refetchHomework={refetchHomework}
        />
        <RejectHomeworkButton
          homeworkId={homework.id}
          refetchHomework={refetchHomework}
        />
      </HStack>
    );
  }

  return actions ?? <></>;
}
